import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from './supabaseClient';

const AuctionAdmin = () => {
  const { auctionCode } = useParams(); // Auction code from URL
  const navigate = useNavigate();

  const [auctionDetails, setAuctionDetails] = useState(null); // Auction info
  const [items, setItems] = useState([]); // Items in the auction
  const [newItem, setNewItem] = useState({ name: '', description: '', startingBid: '' }); // Form inputs
  const [loading, setLoading] = useState(false);

  // Fetch auction details and items when page loads
  useEffect(() => {
    const fetchAuctionDetails = async () => {
      const { data: auction, error: auctionError } = await supabase
        .from('auctions')
        .select('*')
        .eq('auction_code', auctionCode)
        .single();

      if (auctionError) {
        console.error('Error fetching auction details:', auctionError);
      } else {
        setAuctionDetails(auction);
        fetchAuctionItems();
      }
    };

    const fetchAuctionItems = async () => {
      const { data: auctionItems, error: itemsError } = await supabase
        .from('auction_items')
        .select('*')
        .eq('auction_code', auctionCode);

      if (itemsError) {
        console.error('Error fetching auction items:', itemsError);
      } else {
        setItems(auctionItems);
      }
    };

    fetchAuctionDetails();
  }, [auctionCode]);

  // Handle adding a new item
  const handleAddItem = async (e) => {
    e.preventDefault();
    setLoading(true);

    const { name, description, startingBid } = newItem;
    if (!name || !startingBid) {
      alert('Please fill in all required fields.');
      setLoading(false);
      return;
    }

    const { error } = await supabase
      .from('auction_items')
      .insert([{ auction_code: auctionCode, name, description, starting_bid: startingBid }]);

    if (error) {
      console.error('Error adding item:', error);
      alert('Error adding item. Please try again.');
    } else {
      setNewItem({ name: '', description: '', startingBid: '' });
       // Refresh list
      alert('Item added successfully.');
    }
    setLoading(false);
  };

  // Manage auction navigation
  const handleManageAuction = () => {
    navigate(`/admin/${auctionCode}`);
  };

  return (
    <div className="auction-admin">
      <h1>Auction Admin</h1>
      {auctionDetails ? (
        <div className="auction-details">
          <h2>{auctionDetails.auction_name}</h2>
          <p>{auctionDetails.description}</p>
          <p><strong>Auction Code:</strong> {auctionDetails.auction_code}</p>
        </div>
      ) : (
        <p>Loading auction details...</p>
      )}

      <hr />

      <h2>Manage Items</h2>
      <form onSubmit={handleAddItem} className="add-item-form">
        <label>
          Name:
          <input
            type="text"
            value={newItem.name}
            onChange={(e) => setNewItem({ ...newItem, name: e.target.value })}
            required
          />
        </label>
        <label>
          Description:
          <textarea
            value={newItem.description}
            onChange={(e) => setNewItem({ ...newItem, description: e.target.value })}
          />
        </label>
        <label>
          Starting Bid:
          <input
            type="number"
            value={newItem.startingBid}
            onChange={(e) => setNewItem({ ...newItem, startingBid: e.target.value })}
            required
          />
        </label>
        <button type="submit" disabled={loading}>
          {loading ? 'Adding Item...' : 'Add Item'}
        </button>
      </form>

      <hr />

      <h2>Current Items</h2>
      {items.length > 0 ? (
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Description</th>
              <th>Starting Bid</th>
              <th>Current Bid</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.id}>
                <td>{item.name}</td>
                <td>{item.description}</td>
                <td>{item.starting_bid}</td>
                <td>{item.current_bid}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No items available for this auction yet.</p>
      )}

      <hr />

      <button onClick={handleManageAuction} className="manage-button">
        Manage Auction
      </button>
    </div>
  );
};

export default AuctionAdmin;
